/**
 * User: herbert
 * Date: 22.02.16
 * Time: 17:18
 */

export const STEP_SCOPE = 'scope';
export const STEP_CONFIG = 'config';
export const STEP_PARAMETERS = 'parameters';
export const STEP_HEIGHT = 'height';
//export const STEP_UPLOAD = 'upload';
//export const STEP_FOTO = 'foto';
export const STEP_SUMMARY = 'summary';
export const STEP_DATASHEET = 'datasheet';


export const STEPS = [
	STEP_SCOPE,
	STEP_CONFIG,
	STEP_SUMMARY,
	STEP_DATASHEET,
	// das sind steps, die direkt angesprungen werden:
	STEP_PARAMETERS,
	STEP_HEIGHT,
	//STEP_UPLOAD,
	//STEP_FOTO,
];
